import React from "react";

import CommonCard from "components-v2/kpi/common-card";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";


import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function TeamApprovalRateCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["team-approval-rate", tagId],
    queryFn: async () => {
      const response = await apiRoot.get("kpi/team-approval-rate", {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const rate = data?.approvalRate ?? 0;
  const totalLogged = data?.loggedHours ?? 0;
  const totalApproved = data?.approvedHours ?? 0;
  const totalUnapproved = data?.unapprovedHours ?? 0;



  const { title, description } = HOME_CARD_CONTENT.teamApprovalRate;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : rate,
        unit: "%",
        details: [
          { label: "Logged Hours", value: `${totalLogged}h` },
          { label: "Approved Hours", value: `${totalApproved}h` },
          { label: "Unapproved Hours", value: `${totalUnapproved}h` }
        ],
      }}
      percentage={rate}
      isLoading={isLoading}

    />
  );
}
